export function OrderItemsCard({ items }) {
  return (
    <div className="bg-card border border-border rounded-lg overflow-x-auto" data-testid="order-items-card">
      <h2 className="text-xl font-bold uppercase tracking-tight px-5 pt-4">SKU Lines ({items.length})</h2>
      <table className="w-full text-sm mt-2 min-w-[900px]" data-testid="order-items-table">
        <thead>
          <tr className="border-b border-border text-left">
            {["#", "SKU / Product", "HSN", "Qty", "UOM", "Rate", "Taxable", "GST", "Total", "Stock", "Shipped"].map((h) => (
              <th key={h} className="px-3 py-2 text-[10px] font-mono uppercase tracking-widest text-muted-foreground whitespace-nowrap">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {items.map((i) => (
            <tr key={i.line_no} className="border-b border-border/50" data-testid={`item-row-${i.line_no}`}>
              <td className="px-3 py-2.5 metric text-muted-foreground">{i.line_no}</td>
              <td className="px-3 py-2.5">
                <span className="metric font-bold text-primary">{i.sku}</span> <span className="text-muted-foreground">{i.product_name}</span>
                {i.customer_sku && <span className="block text-[10px] font-mono text-muted-foreground">cust SKU: {i.customer_sku}</span>}
              </td>
              <td className="px-3 py-2.5 metric text-xs">{i.hsn || "—"}</td>
              <td className="px-3 py-2.5 metric">{i.quantity.toLocaleString()}</td>
              <td className="px-3 py-2.5 text-xs">{i.uom}</td>
              <td className="px-3 py-2.5 metric">₹{i.rate}</td>
              <td className="px-3 py-2.5 metric">₹{i.taxable?.toLocaleString("en-IN")}</td>
              <td className="px-3 py-2.5 metric text-xs">{i.tax_type} {i.gst_percent}%</td>
              <td className="px-3 py-2.5 metric font-bold">₹{i.line_total?.toLocaleString("en-IN")}</td>
              <td className="px-3 py-2.5 text-xs" data-testid={`item-stock-${i.line_no}`}>
                {i.stock && (
                  <span className={i.stock.status === "available" || i.shipped >= i.quantity ? "text-signal-green" : "text-signal-red"}>
                    {i.stock.status === "available" ? "🟢 avail " : "🔴 short "}
                    {i.stock.free?.toLocaleString()} free{i.stock.reserved_for_order > 0 && ` · ${i.stock.reserved_for_order.toLocaleString()} reserved`}
                  </span>
                )}
              </td>
              <td className="px-3 py-2.5 metric text-xs">{(i.shipped || 0).toLocaleString()} / {i.quantity.toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
